"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constellation_1 = require("@zillow/constellation");
const react_1 = __importDefault(require("react"));
const formatPercentage_1 = require("../../utils/formatPercentage");
const payments_1 = require("../../utils/payments");
const RateSummaryModal = ({ principal, thirtyYearRate, thirtyYearRateText, thirtyYearApr, thirtyYearPoints, fifteenYearRate, fifteenYearRateText, fifteenYearApr, fifteenYearPoints, sevenYearArmRate, sevenYearArmRateText, sevenYearArmApr, sevenYearArmPoints, }) => {
    const currentDate = new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
    const ModalBody = () => (react_1.default.createElement(constellation_1.Box, { sx: {
            padding: '0 $spacing.lg',
        } },
        react_1.default.createElement(constellation_1.Heading, { level: "3", marginBottom: "md" }, "Legal disclosures"),
        react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "md" },
            "Your loan's interest rate and APR will depend upon the specific characteristics of your transaction and your individual credit history. These figures are for estimation purposes only and may not reflect the exact terms of your loan. This is not a commitment to lend. Rates current as of: ",
            currentDate,
            "."),
        react_1.default.createElement(constellation_1.Heading, { level: "5", marginBottom: "xs" }, "30-Year Fixed Rate Conventional Loan Example"),
        react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "md" },
            "Interest rate of ",
            thirtyYearRateText,
            " (",
            (0, formatPercentage_1.formatPercentage)(thirtyYearApr),
            " APR) calculated for a mortgage loan of $",
            principal.toLocaleString(),
            ", with a monthly payment of $",
            (0, payments_1.calculateMonthlyPayment)(principal, thirtyYearRate, 30).toLocaleString(),
            ". Rate assumes a down payment of 20% and includes",
            ' ',
            thirtyYearPoints.toLocaleString(),
            " points, paid at closing. Payment amount is for principal and interest only and does not include taxes or insurance; actual payment obligation will be greater."),
        react_1.default.createElement(constellation_1.Heading, { level: "5", marginBottom: "xs" },
            "15-Year Fixed Rate Conventional Loan Example",
            ' '),
        react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "md" },
            "Interest rate of ",
            fifteenYearRateText,
            " (",
            (0, formatPercentage_1.formatPercentage)(fifteenYearApr),
            " APR) calculated for a mortgage loan of $",
            principal.toLocaleString(),
            ", with a monthly payment of $",
            (0, payments_1.calculateMonthlyPayment)(principal, fifteenYearRate, 15).toLocaleString(),
            ". Rate assumes a down payment of 20% and includes",
            ' ',
            fifteenYearPoints.toLocaleString(),
            " points, paid at closing. Payment amount is for principal and interest only and does not include taxes or insurance; actual payment obligation will be greater."),
        react_1.default.createElement(constellation_1.Heading, { level: "5", marginBottom: "xs" }, "7/6 Adjustable Rate Mortgage Loan Example"),
        react_1.default.createElement(constellation_1.Paragraph, { marginBottom: "md" },
            "Interest rate of ",
            sevenYearArmRateText,
            " (",
            (0, formatPercentage_1.formatPercentage)(sevenYearArmApr),
            " APR) for the first seven (7) years of the loan calculated for a mortgage loan of $",
            principal.toLocaleString(),
            ", with a monthly payment of $",
            (0, payments_1.calculateMonthlyPayment)(principal, sevenYearArmRate, 7).toLocaleString(),
            ". Rate assumes a down payment of 20% and includes",
            ' ',
            sevenYearArmPoints.toLocaleString(),
            " points, paid at closing. After the first seven (7) years of the loan, payment can change every six months for the remaining loan term. Payment amount is for principal and interest only and does not include taxes or insurance; actual payment obligation will be greater."),
        react_1.default.createElement(constellation_1.Heading, { level: "5", marginBottom: "xs" }, "For all rates shown, unless otherwise noted, we assumed:"),
        react_1.default.createElement(constellation_1.List, null,
            react_1.default.createElement(constellation_1.List.Item, { paddingY: "none" }, "Debt-to-income ratio less than 43%"),
            react_1.default.createElement(constellation_1.List.Item, { paddingY: "none" }, "Credit score of 740 or greater"),
            react_1.default.createElement(constellation_1.List.Item, { paddingY: "none" }, "Closing costs, including points, are paid at closing"),
            react_1.default.createElement(constellation_1.List.Item, { paddingY: "none" }, "Loan is to secure a single-family home used as a primary residence in the state of California"))));
    return (react_1.default.createElement(constellation_1.Trigger, { triggered: ({ isOpen, onClose, }) => {
            const modalCloseHandler = () => {
                onClose();
            };
            return (react_1.default.createElement(constellation_1.ModalDialog, { size: "lg", isOpen: isOpen, onClose: modalCloseHandler, scrollDocument: true, dividers: false, renderHeader: react_1.default.createElement(react_1.default.Fragment, null), renderBody: ModalBody, renderFooter: react_1.default.createElement(react_1.default.Fragment, null) }));
        } },
        react_1.default.createElement(constellation_1.TextButton, { fontType: "bodySmallHeading", onClick: () => { } }, "See legal disclosures")));
};
exports.default = RateSummaryModal;
